import React, { useEffect, useState } from 'react'
import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { Web3Modal } from '@web3modal/react'
import { configureChains, createConfig, WagmiConfig } from 'wagmi'
import { BSC_CHAIN_ID, CHAIN_INFO, ETHEREUM_CHAIN_ID, POLYGON_CHAIN_ID } from '@/constants'

export type IWeb3ContextProps = {
  children: React.ReactNode
}
const chains = [CHAIN_INFO[ETHEREUM_CHAIN_ID], CHAIN_INFO[BSC_CHAIN_ID], CHAIN_INFO[POLYGON_CHAIN_ID]]
const projectId = '50780720498c0d3b0b5f8069b15bebad'

const { publicClient } = configureChains(chains, [w3mProvider({ projectId })])
const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, chains }),
  publicClient,
})
const ethereumClient = new EthereumClient(wagmiConfig, chains)

const Web3Context: React.FC<IWeb3ContextProps> = ({ children }) => {
  const [isMounted, setIsMounted] = useState<boolean>(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) return null

  return (
    <>
      <WagmiConfig config={wagmiConfig}>{children}</WagmiConfig>
      <Web3Modal
        themeVariables={{
          '--w3m-z-index': '1302',
          '--w3m-background-color': '#BFFF0B',
          '--w3m-accent-color': '#BFFF0B',
        }}
        projectId={projectId}
        defaultChain={CHAIN_INFO[ETHEREUM_CHAIN_ID]}
        ethereumClient={ethereumClient}
      />
    </>
  )
}

export default Web3Context
